import { render, staticRenderFns } from "./My-5-Receiving.vue?vue&type=template&id=22deebe4&"
import script from "./My-5-Receiving.vue?vue&type=script&lang=js&"
export * from "./My-5-Receiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports